import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryQuickEntry() {
  return (
    <section aria-labelledby="category-entry-title">
      <div className="flex items-end justify-between gap-4 mb-4">
        <div>
          <h2 id="category-entry-title" className="flex items-center gap-2 font-heading text-lg md:text-xl font-bold text-foreground-950">
            <span className="w-1 h-5 rounded-full bg-accent-500" />
            题材分类
          </h2>
          <p className="mt-1 text-[12px] text-foreground-500">按题材快速进入，找到对味的那一部</p>
        </div>
        <Link
          to="/list"
          className="shrink-0 text-[12px] text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-0.5"
        >
          全部作品
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="group flex items-center gap-2.5 rounded-lg border border-background-200 bg-background-100 px-3 py-3 hover:border-primary-300 hover:bg-background-50 transition-colors cursor-pointer"
          >
            <span className={`w-9 h-9 shrink-0 rounded-md flex items-center justify-center ${cat.tint}`}>
              <i className={`${cat.icon} text-lg`} />
            </span>
            <span className="min-w-0">
              <span className="block font-heading text-[13px] font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="block text-[11px] text-foreground-500 truncate">
                {cat.subGenres[0]}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}